import request from '@/service/http'
import { LoginReq, LoginRes } from '../type/login'

export const LoginUrl = '/api/user/login'

export function loginApi(data: LoginReq): Promise<LoginRes> {
  return request<LoginRes, LoginReq>({
    url: LoginUrl,
    method: 'post',
    data: data,
    requestConfig: {
      checked(data) {
        if (!data.data?.access_token) return false
        return true
      }
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    return res
  })
}
